export default __webpack_public_path__ + "static/media/laptop.b44b37c6.svg";